import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useState } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import ReactAwesomeReveal from 'react-awesome-reveal';
import { getFinalKeyFrames } from './Reveal.utils';
import useIsTouchScreenDevice from '../../../../hooks/use-is-touch-screen-device';
import { ChildrenPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { AnimationsSettingsContext } from '../../context';
import { DEFAULT_REVEAL_PROPS } from '../../reveal.constants';
import { BaseRevealOptionsPropTypes } from '../../types/reveal.types';
import './Reveal.less';
var defaultProps = _objectSpread(_objectSpread({}, DEFAULT_REVEAL_PROPS), {}, {
  className: '',
  children: null,
  content: null,
  initialKeyFrames: {}
});
export default function Reveal(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    keyFrames = _ref.keyFrames,
    initialKeyFrames = _ref.initialKeyFrames,
    duration = _ref.duration,
    delay = _ref.delay,
    disableAnimation = _ref.disableAnimation,
    disableAnimationOnMobile = _ref.disableAnimationOnMobile,
    cascade = _ref.cascade,
    cascadeFactor = _ref.cascadeFactor,
    triggerOnce = _ref.triggerOnce,
    onVisibilityChangeProp = _ref.onVisibilityChange,
    fraction = _ref.fraction,
    noContainer = _ref.noContainer;
  var _useIsTouchScreenDevi = useIsTouchScreenDevice(),
    isTouchScreenDevice = _useIsTouchScreenDevi.isTouchScreenDevice;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    animatedOnce = _useState2[0],
    setAnimatedOnce = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    displayInitialAnimation = _useState4[0],
    setDisplayInitialAnimation = _useState4[1];
  var finalContent = content || children;
  var animationsContext = useContext(AnimationsSettingsContext);
  var finalKeyFrames = getFinalKeyFrames(keyFrames, {
    initialKeyFrames: initialKeyFrames,
    displayInitialAnimation: displayInitialAnimation
  });
  var noAnimation = _isEmpty(finalKeyFrames) || disableAnimation || !_get(animationsContext, 'enabled', true) || isTouchScreenDevice && disableAnimationOnMobile;
  var finalClassName = classNames((_classNames = {
    reveal: true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, 'no-animation', noAnimation), _defineProperty(_classNames, 'no-animation-mobile', disableAnimationOnMobile), _defineProperty(_classNames, 'is-touch-screen-device', isTouchScreenDevice), _classNames));
  if (noAnimation) {
    return noContainer ? finalContent : /*#__PURE__*/React.createElement("div", {
      className: finalClassName
    }, finalContent);
  }
  if (_isEmpty(finalContent)) {
    return null;
  }
  function onVisibilityChange(inView, intersectionObserverEntry) {
    if (inView && !animatedOnce) {
      setTimeout(function () {
        setAnimatedOnce(true);
      }, duration + delay);
    }
    if (!inView && animatedOnce && displayInitialAnimation) {
      setDisplayInitialAnimation(false);
    }
    if (onVisibilityChangeProp) {
      onVisibilityChangeProp(inView, intersectionObserverEntry);
    }
  }
  return /*#__PURE__*/React.createElement(ReactAwesomeReveal, {
    className: finalClassName,
    duration: duration,
    delay: delay,
    cascade: cascade,
    damping: cascadeFactor,
    triggerOnce: triggerOnce,
    onVisibilityChange: onVisibilityChange,
    keyframes: finalKeyFrames,
    fraction: fraction
  }, finalContent);
}
Reveal.defaultProps = defaultProps;